import { SectionLabel } from '@/components/ui/section-label';
import { cn } from '@/lib/utils';

export type SectionRefs = {
  operatorRef: React.RefObject<{ validate: () => boolean } | null>;
  durationTotalRef: React.RefObject<{ validate: () => boolean } | null>;
  durationPieceRef: React.RefObject<{ validate: () => boolean } | null>;
  lubTypeRef: React.RefObject<{ validate: () => boolean } | null>;
  toolStateRef: React.RefObject<{ validate: () => boolean } | null>;
  toolChangeRef: React.RefObject<{ validate: () => boolean } | null>;
};

/** Sticky section band of the trace view and edit bodies (shared by both). */
export function SectionHeader({ title }: { title: string }) {
  return (
    <div className="sticky top-0 z-10 flex items-center bg-muted/40 px-4 py-2">
      <SectionLabel>{title}</SectionLabel>
    </div>
  );
}

export function FieldRow({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('px-4 py-2 border-b border-border/40 last:border-0', className)}>
      {children}
    </div>
  );
}
